<template>
    <div>   
        <!-- <v-layout column class="ma-9">
            
            <v-btn color="blue" @click="LOG_DATA('btn get')" class="mb-1">Log items</v-btn>
            <v-btn color="blue" @click="TEST_INITIATE()" class="mb-1">Test Initiate</v-btn>
            <v-btn color="blue" @click="DB_ADD()"  class="mb-1">Add Item DB</v-btn>
            <v-btn color="blue" @click="GET_DATA()" class="mb-1">upload my Items</v-btn>
            <v-btn color="blue" @click="" class="mb-1">upload my Items</v-btn>
        </v-layout> -->


        <v-container grid-list-xl> 
            <v-layout align-center="" justify-center="">
                <v-col sm="12" cols="12">
                    <br>
                    <v-card > 
                        <mbs-page-tab 
                            :items="MY_LINKS"/> 
                        <mbs-item-manager
                            :add_vertical_lines="true"
                            :top_label="false"
                            :filter_date="true"
                            :filter_date_value="'local_created_at'"
                            :filter_default_days="'90'"
                            :name_items="NAME_ITEMS"
                            :name_item="NAME_ITEM"
                            :value_items="VALUE_ITEMS"
                            :value_item="VALUE_ITEM"
                            :field_items="FIELD_ITEMS"
                            :header_items="HEADER_ITEMS" 
                            :data_items="BothQuotations"   
                            :is_joined="true"  
                            :path_item="SALES_PATH"   
                            :total_item_values="TOTAL_ITEM_VALUES"  

                            :table_actions="table_actions" 
                            @SELECT_TABLE_ACTION="TABLE_ACTION"
                            @SELECT_ITEM_ACTION="ITEM_ACTION"
                        />
                    </v-card>
                    <br><br>
                </v-col>  
            </v-layout>
        </v-container>  
        <div>
            
        </div>
    </div> 
</template>

<script>
    import DATA from '../../../plugins/DATA'
    import DB from '../../../plugins/DB' 
    import {mapState} from "vuex"
    let PAGE_NAME = DATA.ITEMS.QUOTATIONS.values    
    export default {
        name:PAGE_NAME, 
        data() {
            return {
                PAGE_LOAD:false,  
                PAGE_CURRENT:1,
                PAGE_SIZE:10,

                NAME_ITEMS:'ISSUED '+DATA.ITEMS.QUOTATIONS.names,
                NAME_ITEM:DATA.ITEMS.QUOTATIONS.name,
                VALUE_ITEMS:DATA.ITEMS.QUOTATIONS.values,
                VALUE_ITEM:DATA.ITEMS.QUOTATIONS.value,  

                FIELD_ITEMS:[
                    {type:"number",name:"code",value:"code",label:"Code",required:true,sm:12,md:12}, 
                    {type:"text",name:"name",value:"name",label:"Name",required:true,sm:12,md:12},   
                ],     
                table_actions:[  
                    {type:"btn",action:"sales_return",color:"secondary", outlined:false,  text:"Sales Return"},  
                    {type:"action",btn:true,icon:"mdi-refresh",action:"refresh",color:"secondary", outlined:false,  text:"Refresh"},   
                    {type:"action",icon:"mdi-microsoft-excel",action:"export_excel",color:"secondary", outlined:false,  text:"Export to Excel"},  
                ],
                TOTAL_ITEM_VALUES:[ 
                    {name:'Total Items',value:'total_quantity'},
                    // {name:'Total Cost Price',value:'total_cost_price',show_value:'total_cost_price_',money:true},
                    {name:'Total Sales Price',value:'total_sold_price',show_value:'total_sold_price_',money:true},
                ], 
            }
        },
        created() {
            try {
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted() {
            try {
                this.MBS.actions.header({
                    show:true,
                    type:'subToolbar', 
                    images:null,
                    color:'black',
                    height:"300",
                    opacity:'0.1'
                })
                this.FEEDBACKS(1000)  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME, 
                }) 
            }
            
        },
        computed: {
            route(){
                return this.$route
            },
            vs(){
                return this.$vuetify.breakpoint
            }, 
            vsh(){
                return this.vs.height
            }, 
            MY_LINKS(){  
                let thisLinks = this.MBS.actions.FIND_SUB_LINKS("sale",1,true) 
                return thisLinks
            }, 
            SALES_PATH(){  
                let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.issued_quotations,true) 
                return path
            },  
            /////////
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
            }),
            ...mapState({
                Quotations: state=> state.items[(DATA.ITEMS.QUOTATIONS.values).toUpperCase()],
                JoinedQuotations: state=> state.join[(DATA.ITEMS.QUOTATIONS.values).toUpperCase()], 
                LocalQuotations: state=> state.locals[(DATA.ITEMS.LOCAL_QUOTATIONS.values).toUpperCase()],
                JoinedLocalQuotations: state=> state.join[(DATA.ITEMS.LOCAL_QUOTATIONS.values).toUpperCase()], 
            }), 
            
            
            HEADER_ITEMS(){
                return [ 
                {id:1,name:"General",title:true}, 
                    {id:0,name:"",value:'icon_image',color:"primary",size:40,tile:true,show:true},
                    {id:0,name:"Number",value:'no',show:false},   
                    {id:0,name:"Date",value:'local_created_at_',show:true},   
                    // {id:0,name:"Payment",value:"payment_method_name",show:true},     
                    {id:0,name:"S. Key",value:'day_shift_key',show:false},   
                    {id:0,name:"C. Key",value:'cashup_key',show:false},      
                    {id:0,name:"Quotation No.",value:"receipt_number",align:"center",show:true},         
                    {id:0,name:"Outlet",value:"outlet_name",show:false},         
                    {id:0,name:"Teller",value:"teller_name",show:false},         
                    {id:0,name:"Till",value:"till_name",show:false},         
                    {id:0,name:"Customer",value:'customer_name',show:true},   
                    {id:0,name:"Account",value:'receivable_name',show:true},   
                    {id:0,name:"Items",value:'total_quantity_',align:'right',show:true},    
                    {id:0,name:"Price",value:'total_price_',align:'right',show:true},   
                    {id:0,name:"update",value:'updated_at',show:false},   
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"View  Quotation",action:"view_quotation",icon:"mdi-eye"}, 
                        {name:"Archive Quotation",action:"archive_item",icon:"mdi-delete"},   
                    ]}, 
                ]
            },  
            LocalQuotationsData(){ 
                let us = this.us
                let uid = us?us.uid:null 
                let LocalQuotations = this.LocalQuotations
                let JoinedLocalQuotations = this.JoinedLocalQuotations
                let items = JoinedLocalQuotations?JoinedLocalQuotations:LocalQuotations 
                if(!items){return null}
                let mys = items.filter(sale=>{
                    return sale.created_uid == uid
                }) 
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("local_created_at",false)) 
                return list
            },
            QuotationsData(){
                let Quotations = this.Quotations
                let JoinedQuotations = this.JoinedQuotations
                let items = JoinedQuotations?JoinedQuotations:Quotations
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("local_created_at",false))  
                return list 
            },
             
            BothQuotations(){
                let locals = this.LocalQuotationsData
                let quotations = this.QuotationsData

                if(!quotations && !locals){return null}
                if(quotations && !locals){return quotations}
                if(!quotations && locals){return locals}

                let both = [...quotations]
                locals.forEach(element => {
                    let item = quotations.find(item=>{
                        return item.key == element.key
                    })
                    if (!item) {
                        both.push(element)
                    } 
                });
                let list = [...both]
                list.sort(this.MBS.actions.dynamicSort("local_created_at",false)) 
                
                return list
            }

        },
        methods: { 
            //----------------[TESTING FUNCTIONS]----------------
            LOG_DATA(action){
                console.log('****---------------',action,'----------------***');
                console.log(this.Quotations,'Quotations');
                console.log(this.JoinedQuotations,'JoinedQuotations');
                console.log(this.LocalQuotations,'LocalQuotations');
                console.log(this.JoinedLocalQuotations,'JoinedLocalQuotations');
            },
            async TEST_INITIATE(action){
                let res = await this.$store.dispatch("initiate_locals",{
                    // names:[
                    //     DATA.ITEMS.LOCAL_DAYS_SHIFTS.values,
                    // ]
                })
                console.log(res,'re..........');
            }, 
            async GET_DATA(action){
                let res = await this.$store.dispatch("fi_get_item",{
                    name:DATA.ITEMS.QUOTATIONS.values,
                    cash:true
                })
                console.log(res,'re..........');
            },
            async DB_ADD(action){
                let moment = this.MBS.date.moment
                let key = moment?moment().valueOf():null
                let res = await DB.addItems({
                    name:DATA.ITEMS.LOCAL_QUOTATIONS.values,
                    data:{
                        key:key,
                        order_type:"Testing Quotation",
                        day_shift_key:"1693646291237",
                        cashup_key:"1693646316058",
                        company_key:"testing-bar",
                    },
                    update_locals:true, 
                })
                console.log(res,'re..........');
            },

            //------
            TABLE_ACTION(action,item){
                try { 
                    if (action == "order_stock") { 
                        let link = this.MBS.actions.COMPANY_LINK("/stock/stock-control/sales-return",true)
                        this.MBS.actions.go(link)
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            ITEM_ACTION(action,item){
                try { 
                    let link = "/stock/stock-control/"+(item?item.key:null)
                    const path = this.MBS.actions.COMPANY_LINK(link,true) 
                    console.log(item,'...');
                    if (action == "view_quotation") {
                        let account_type = item?item.account_type:null
                        let receipt_key = item?item.key:null
                        this.MBS.actions.go("/sales-quotation/"+receipt_key) 
                         
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
             
            //---------------[MAIN FUNCTIONS]------------ 
            DIALOG_YES(action){ 
                try {
                    if (action.code) {
                        if (action.code ===PAGE_NAME+'=ADD-ITEM') {
                            if (action.YES) {
                                if (this.input.check) { 
                                    this.input.check = false 
                                    setTimeout(() => {
                                        this.input.loading = true 
                                        this.$store.dispatch("fi_add",{
                                            action:this.VALUE_ITEM,
                                            path:this.PATH_ITEM,
                                            data:action.data,
                                            us:this.us
                                        })
                                    }, ACTION_TIME);  
                                }   
                            } else {
                                
                            }
                        }  
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },  
            FEEDBACKS(time){ 
                try {
                    if (!time) { time=400 }
                    setTimeout(()=>{
                        let us = this.loggedUser 
                        let ps = this.processes
                        let ld = this.loading
                        let res = this.responses

                        //Check process 
                        if (ps) {
                            let gettingItems = ps.find(process=>{
                                return process.name == 'getting/'+this.VALUE_ITEMS
                            })
                            
                             
                             
                        }else{
                            this.PAGE_LOAD =true
                        } 
                    },time)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FEEDBACKS',
                        page:PAGE_NAME, 
                    })  
                } 
            }, 
        },
        watch: { 
            us:{ 
                handler:"FEEDBACKS",
                immediate:true
            } ,
            loading:{ 
                handler:"FEEDBACKS",
                immediate:true
            } ,
            processes:{ 
                handler:"FEEDBACKS",
                immediate:true
            },
            responses:{ 
                handler:"FEEDBACKS",
                immediate:true
            },
            Quotations(){ 
                this.LOG_DATA('Quotations')
               return {immediate:true}
            },
            LocalQuotations(){ 
                this.LOG_DATA('LocalQuotations')
                return {immediate:true}
            } 
        },
    }
</script>
 
